/* eslint-disable no-plusplus */
import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import {
  Box,
  Button,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Cancel } from '../../media/images/Cancel';
import { AnalystTubeCountDatatablestyle } from './utils/Constant';
import ComponentTextInput from '../../Common/ComponentTextinput/ComponentTextInput';
import { showErrorToaster, showSuccessToaster } from '../../Common/ComponentToast/ComponentSuccessToasts';
import { RootState } from '../../redux/rootState';
import { getChartListSuccess } from '../VesselInformation/redux/tubeChart/tubeChartSlice';
import { CircleInfo } from '../VesselInformation/utils/tubeChartTypes';

interface IEnhanceTubeChartGridModal {
  open: boolean;
  handleClose: () => void;
  rows: string;
  tubes: string;
}
type HiddenCoordinates = Record<number, number[]>;

export default function EnhanceTubeChartGridModal({
  open, handleClose, rows, tubes,
}: IEnhanceTubeChartGridModal) {
  const { control } = useForm();
  const dispatch = useDispatch();
  const [errRow, setErrRow] = useState(rows);
  const [errTube, setErrTube] = useState(tubes);
  const { chartList } = useSelector((state: RootState) => state.TubeChartReducer);

  const closeModal = () => {
    handleClose();
  };
  function expandGrid(existingGrid: CircleInfo[], oldRows: number, oldTubes: number, newRows: number, newTubes: number) {
    const result = [...existingGrid];

    // Add new columns (tubes)
    if (newTubes > oldTubes) {
      for (let r = 0; r < oldRows; r++) {
        for (let c = oldTubes; c < newTubes; c++) {
          result.push({
            Position: `${r},${c}`,
            Stroke: '#FF000000',
            Fill: '#00FFFFFF',
          });
        }
      }
    }

    // Add new rows
    if (newRows > oldRows) {
      for (let r = oldRows; r < newRows; r++) {
        for (let c = 0; c < newTubes; c++) {
          result.push({
            Position: `${r},${c}`,
            Stroke: '#FF000000',
            Fill: '#00FFFFFF',
          });
        }
      }
    }

    return result;
  }
  function deepCloneHidden(hiddenObj: HiddenCoordinates): HiddenCoordinates {
    const clone: HiddenCoordinates = {};
    Object.keys(hiddenObj).forEach((key) => {
      const numKey = Number(key);
      clone[numKey] = [...hiddenObj[numKey]];
    });
    return clone;
  }
  function updateHiddenCoordinates(hiddenObj: HiddenCoordinates, oldRows: number, oldTubes: number, newRows: number, newTubes: number) {
    const updated = deepCloneHidden(hiddenObj);

    // If new columns added
    if (newTubes > oldTubes) {
      for (let r = 0; r < oldRows; r++) {
        if (!updated[r]) updated[r] = [];

        for (let c = oldTubes; c < newTubes; c++) {
          updated[r].push(c);
        }
      }
    }

    // If new rows added
    if (newRows > oldRows) {
      for (let r = oldRows; r < newRows; r++) {
        updated[r] = [];

        for (let c = 0; c < newTubes; c++) {
          updated[r].push(c);
        }
      }
    }

    return updated;
  }

  const handleEnhance = () => {
    if (Number(errRow) > 100) {
      showErrorToaster('You can add upto 100 rows');
    } else if (Number(errTube) > 130) {
      showErrorToaster('You can add upto 130 tubes per row');
    } else if (Number(errRow) === Number(rows) && Number(errTube) === Number(tubes)) {
      showErrorToaster('Grid enhancement requires increasing either the total rows or the tubes per row beyond their default values');
    } else if (Number(errRow) < Number(rows) || Number(errTube) < Number(tubes)) {
      showErrorToaster('The total number of rows and tubes cannot be lower than the default chart size');
    } else {
      const chart = chartList[0];

      const grid = expandGrid(chart.CircleInfos, Number(rows), Number(tubes), Number(errRow), Number(errTube));
      const hiddenGrid = updateHiddenCoordinates(chart.RemovedConfig, Number(rows), Number(tubes), Number(errRow), Number(errTube));

      const payData = {
        ...chart,
        NumOfRows: errRow,
        RowLength: errTube,
        CircleInfos: grid,
        RemovedConfig: hiddenGrid,
      };

      dispatch(getChartListSuccess([payData]));
      showSuccessToaster('Grid size increased successfully');
      closeModal();
    }
  };

  return (
    <Modal
      open={open}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={AnalystTubeCountDatatablestyle}>
        <div className="customerInfo_container flex-row">
          <div className="customerInfo">
            Enhance Grid Size
          </div>
          <div className="cancel-icon" onClick={() => closeModal()}>
            <Cancel />
          </div>
        </div>
        <div className="analystTubeCountModalHeaderRowAlign">
          <div className="div_label_text" style={{ width: '90%', marginTop: '10px' }}>
            <label className="label_Style_Customer">Rows</label>
            <ComponentTextInput
              name="newRows"
              id="newRows"
              control={control}
              type="number"
              size="small"
              defaultValue={rows}
              handleChange={(e, val) => setErrRow(val)}
              maxTextLength={3}
            />
          </div>
          <div className="div_label_text" style={{ width: '90%' }}>
            <label className="label_Style_Customer">Tubes per row</label>
            <ComponentTextInput
              name="newTubes"
              id="newTubes"
              control={control}
              type="number"
              size="small"
              defaultValue={tubes}
              handleChange={(e, val) => setErrTube(val)}
              maxTextLength={3}
            />
            {/* <p className="bayLengthErr">{errTube}</p> */}
          </div>

          <Button
            className="button_save_and_next"
            // className={isButtonEnabled ? 'button_save_and_next' : 'button_cancel cursorNotAllowed'}
            sx={{ height: 36, marginTop: '20px' }}
            onClick={handleEnhance}
          >
            Enhance Grid
          </Button>
        </div>
      </Box>
    </Modal>
  );
}
